
import { Button } from "@/components/ui/button";
import { FilePlus, Loader2 } from "lucide-react";

interface PolicyFormActionsProps {
  onCancel?: () => void;
  onSubmit: () => void;
  isSubmitDisabled: boolean;
  submitLabel?: string;
  isSubmitting?: boolean;
}

export const PolicyFormActions = ({
  onCancel,
  onSubmit,
  isSubmitDisabled,
  submitLabel = "Create Policy",
  isSubmitting = false
}: PolicyFormActionsProps) => {
  const createButtonClasses = "bg-purple-600 hover:bg-purple-700 text-white";

  return (
    <div className="pt-4">
      {onCancel && (
        <div className="flex justify-end gap-2">
          <Button 
            variant="outline" 
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button 
            onClick={onSubmit} 
            disabled={isSubmitDisabled || isSubmitting}
            className={createButtonClasses}
          >
            {isSubmitting ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <FilePlus className="mr-2" />
            )}
            {isSubmitting ? "Creating..." : submitLabel}
          </Button>
        </div>
      )}
      {!onCancel && (
        <Button 
          onClick={onSubmit}
          disabled={isSubmitDisabled || isSubmitting}
          className={`w-full ${createButtonClasses}`}
        >
          {isSubmitting ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <FilePlus className="mr-2" />
          )}
          {isSubmitting ? "Creating..." : submitLabel}
        </Button>
      )}
    </div>
  );
};
